module.exports = __webpack_public_path__ + "static/media/moon.47a3d0bc.png";